import { useEffect, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import { apiService } from '@/services/api'

/** Chave do convite pendente: sobrevive ao redirect de login (local ou Google). */
export const PENDING_INVITE_KEY = 'pending_invite_code'

/**
 * Rota pública /convite/:code — link de convite da campanha (WhatsApp/QR).
 * Logado: ingressa direto pelo código e cai na campanha.
 * Deslogado: guarda o convite, passa pelo login e volta para cá.
 */
export function JoinInviteScreen() {
  const { code } = useParams<{ code: string }>()
  const navigate = useNavigate()
  // Guarda contra o duplo-invoke do StrictMode (ingressaria duas vezes)
  const processed = useRef(false)

  useEffect(() => {
    if (!code || processed.current) return
    processed.current = true

    const token = localStorage.getItem('auth_token')
    if (!token) {
      sessionStorage.setItem(PENDING_INVITE_KEY, code)
      toast.info('Entre na sua conta para ingressar na campanha.')
      navigate('/login', { replace: true })
      return
    }

    sessionStorage.removeItem(PENDING_INVITE_KEY)

    apiService
      .joinTableByCode(code)
      .then((result) => {
        toast.success(`Bem-vindo(a) à campanha ${result.table.name}!`)
        navigate(`/detalhes/${result.table.id}`, { replace: true })
      })
      .catch((error: any) => {
        if (error?.status === 400) {
          toast.info('Você já participa desta campanha.')
          navigate('/pagina-inicial', { replace: true })
        } else if (error?.status === 404) {
          toast.error('Convite inválido ou campanha encerrada.')
          navigate('/pagina-inicial', { replace: true })
        } else if (error?.status === 401) {
          // Token expirado: o apiService já redireciona para /login; preserva o convite
          sessionStorage.setItem(PENDING_INVITE_KEY, code)
        } else {
          toast.error('Não foi possível ingressar. Tente novamente.')
          navigate('/pagina-inicial', { replace: true })
        }
      })
  }, [code, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <Loader2 className="h-8 w-8 animate-spin" />
        <p className="text-sm font-medium">Entrando na campanha…</p>
      </div>
    </div>
  )
}
